module.exports = {
  'Adverse drug reaction (when used as intended)':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.ADVERSE_DRUG_REACTION',
  'Contra-indication to the use of the medicine in relation to drugs or conditions':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.CONTRA_INDICATION',
  'Mismatching between patient and medicine':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.PATIENT_MEDICINE_MISMATCH',
  'Omitted medicine / ingredient':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.OMITTED_MEDICINE',
  'Patient allergic to treatment':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.PATIENT_ALLERGY',
  'Wrong / omitted / passed expiry date':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.EXPIRY_DATE',
  'Wrong / omitted patient information leaflet':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.INFORMATION_LEAFLET',
  'Wrong / omitted verbal patient directions':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.PATIENT_DIRECTIONS',
  'Wrong / transposed / omitted medicine label':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.MEDICINE_LABEL',
  'Wrong / unclear dose or strength':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.DOSE_STRENGTH',
  'Wrong drug / medicine':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.MEDICINE',
  'Wrong formulation':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.FORMULATION',
  'Wrong frequency':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.FREQUENCY',
  'Wrong method of preparation / supply':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.PREPARATION_METHOD',
  'Wrong quantity':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.QUANTITY',
  'Wrong route':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.ROUTE',
  'Wrong storage':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.STORAGE',
  'Other':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.OTHER',
  'Unknown':'MEDICATIONS.V2.FORM.OPTION.ERROR_TYPE.UNKNOWN'
};
